
import { defineComponent, PropType, computed } from "vue";
import { OutputType } from "@/services/Models";
import { ImagePreview } from "./EditDownload.vue";

export default defineComponent({
  name: "EditDownloadPreview",
  props: {
    isShowPreview: { type: Boolean },
    imagePreview: { type: Object as PropType<ImagePreview[]> },
  },
  setup(props, context) {
    const vAlign = OutputType.vAlign;
    const split = OutputType.split;
    const twoBytwo = OutputType.twoBytwo;
    const splitBySelect = OutputType.splitBySelect;

    const isShowPreviewInner = computed({
      get: () => props.isShowPreview,
      set: (newValue) => {
        context.emit("update:isShowPreview", newValue);
      },
    });
    const enterAction = () => {
      context.emit("enterAction");
    };
    const back = () => {
      context.emit("back");
    };

    return {
      vAlign,
      split,
      twoBytwo,
      splitBySelect,
      isShowPreviewInner,
      enterAction,
      back,
    };
  },
});
